/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationUserSessionIssuerDeletePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationUserSessionIssuerDeletePreflightRequest = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationUserSessionIssuerDeletePreflightSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerDeletePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerDeletePreflightSecurity$Outbound,
    GetOrganizationUserSessionIssuerDeletePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerDeletePreflightSecurityToJSON(
  getOrganizationUserSessionIssuerDeletePreflightSecurity:
    GetOrganizationUserSessionIssuerDeletePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerDeletePreflightSecurity$outboundSchema
      .parse(getOrganizationUserSessionIssuerDeletePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationUserSessionIssuerDeletePreflightRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerDeletePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerDeletePreflightRequest$Outbound,
    GetOrganizationUserSessionIssuerDeletePreflightRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerDeletePreflightRequestToJSON(
  getOrganizationUserSessionIssuerDeletePreflightRequest:
    GetOrganizationUserSessionIssuerDeletePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerDeletePreflightRequest$outboundSchema.parse(
      getOrganizationUserSessionIssuerDeletePreflightRequest,
    ),
  );
}
